import { render, staticRenderFns } from "./expertsTable.vue?vue&type=template&id=c5be296c&scoped=true"
import script from "./expertsTable.vue?vue&type=script&lang=js"
export * from "./expertsTable.vue?vue&type=script&lang=js"
import style0 from "./expertsTable.vue?vue&type=style&index=0&id=c5be296c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5be296c",
  null
  
)

export default component.exports